import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { YomiriLogo } from './YomiriLogo.tsx';

interface YomiriLoadingProps {
  label?: string;
  compact?: boolean;
  fullscreen?: boolean;
}

export function YomiriLoading({
  label = 'Cargando…',
  compact = false,
  fullscreen = false,
}: YomiriLoadingProps) {
  if (compact) {
    return (
      <Box
        role="status"
        aria-label={label}
        aria-busy="true"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1.5,
          p: 1.5,
          color: 'var(--text-secondary)',
          fontSize: 13,
        }}
      >
        <YomiriLogo size={24} markOnly mode="loading" />
        <Typography component="span" sx={{ fontSize: 13, color: 'var(--text-muted)' }}>
          {label}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      role="status"
      aria-label={label}
      aria-busy="true"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: fullscreen ? '100vh' : 280,
        width: '100%',
        p: 4,
        gap: 2.5,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          p: 2.5,
          borderRadius: '24px',
          bgcolor: 'rgba(18, 18, 26, 0.55)',
          backdropFilter: 'blur(16px)',
          border: '1px solid rgba(255, 255, 255, 0.08)',
          boxShadow: '0 12px 40px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.08)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <YomiriLogo size={56} markOnly mode="loading" />
      </Box>
      {label && (
        <Typography
          sx={{
            fontSize: 13,
            fontWeight: 500,
            color: 'var(--text-secondary)',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            opacity: 0.85,
            animation: 'yomiri-glow-pulse 2s ease-in-out infinite',
          }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
}

export function YomiriLoadingScreen({ label = 'Cargando Yomiri…' }: { label?: string }) {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'var(--bg-deepest, #060608)',
        backdropFilter: 'blur(20px)',
      }}
    >
      <YomiriLoading label={label} fullscreen />
    </Box>
  );
}
